import { render } from "./VaccineRecordCompInputs.vue?vue&type=template&id=a7ca69a2"
import script from "./VaccineRecordCompInputs.vue?vue&type=script&lang=js"
export * from "./VaccineRecordCompInputs.vue?vue&type=script&lang=js"
script.render = render

export default script
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QStep,QForm,QFile,QIcon,QStepperNavigation,QBtn,QField,QRadio,QInput});
